'use client'

import { Provider } from 'react-redux'
import { store } from '@/store'
import { useEffect } from 'react'
import useUsersApi from '@/hooks/useUsersApi'
import { usePathname } from 'next/navigation'
import { ROUTES } from '@/shared/constants'

export default function ReduxProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const pathname = usePathname()
  const { getUserLogged } = useUsersApi()

  useEffect(() => {
    if (
      pathname !== ROUTES.LOGIN.PATH &&
      pathname !== ROUTES.REGISTER.PATH &&
      !pathname.startsWith(ROUTES.CREATE_PASSWORD.PATH) &&
      !pathname.startsWith(ROUTES.REQUEST_RESET_PASSWORD.PATH) &&
      !pathname.startsWith(ROUTES.RESET_PASSWORD.PATH)
    ) {
      getUserLogged()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Provider store={store}>{children}</Provider>
}
